var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000121266736026367882100000003031418769713757366_);}\r\n\t.st1{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_1120",
    transform: "translate(579 251.632)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -58.59,
    y: 73.67,
    width: 879.92,
    height: 373.19
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000064327177765841321950000008482820374433017015_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1094",
    transform: "translate(0 0)",
    style: {
      clipPath: "url(#SVGID_00000064327177765841321950000008482820374433017015_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    className: "st1",
    d: "M263.59,190.66v-83.3h31.39v82.01c0,22.64,14.53,38.66,35.02,38.66 c20.29,0,34.81-16.01,34.81-38.66v-82.01h31.61v83.3c0,38.66-27.55,65.99-66.42,65.99C290.93,256.66,263.6,229.32,263.59,190.66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    className: "st1",
    d: "M415.47,232.31l18.16-21.57c13.88,11.96,29.68,19.22,48.26,19.22 c15.8,0,23.92-7.26,23.92-16.45c0-10.46-8.55-13.66-30.97-18.79c-30.97-7.05-52.96-15.81-52.96-44.21 c0-27.12,22.22-45.7,54.25-45.7c23.92,0,42.49,7.48,57.45,20.29l-16.45,22.64c-13.03-10.47-27.76-16.24-41.86-16.24 c-13.46,0-21.56,7.05-21.56,15.81c0,10.68,8.75,14.1,31.39,19.22c31.61,7.04,52.53,16.45,52.53,43.56 c0,27.98-21.14,46.56-57.03,46.56C455.2,256.66,432.57,248.11,415.47,232.31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    className: "st1",
    d: "M591.93,135.77v29.26h73.67v28.4h-73.67v32.25h81.37v28.4H560.31V107.37H673.3v28.4 L591.93,135.77z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    className: "st1",
    d: "M785.45,254.09l-33.53-47.63h-23.28v47.63h-31.39V107.36h66c31.82,0,55.32,20.5,55.32,49.55 c0,21.79-13.24,38.87-33.32,45.91l36.09,51.26H785.45z M728.64,177.63h31.19c15.58,0,26.27-8.11,26.27-20.72 c0-12.6-10.68-20.72-26.27-20.72h-31.19V177.63z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    className: "st1",
    d: "M263.8,295.36h66c31.82,0,55.32,20.5,55.32,49.55s-23.5,49.55-55.32,49.55h-34.61v47.63H263.8 V295.36z M326.39,365.63c15.59,0,26.27-8.11,26.27-20.72c0-12.6-10.68-20.72-26.27-20.72h-31.19v41.44H326.39z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    className: "st1",
    d: "M513.51,413.68v28.4H408.85V295.36h31.61v118.32H513.51z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    className: "st1",
    d: "M538.74,378.65v-83.3h31.39v82.01c0,22.64,14.53,38.66,35.03,38.66 c20.29,0,34.81-16.01,34.81-38.66v-82.01h31.61v83.3c0,38.66-27.55,65.99-66.42,65.99C566.07,444.65,538.74,417.31,538.74,378.65 "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    className: "st1",
    d: "M695.75,420.3l18.15-21.57c13.88,11.96,29.69,19.22,48.27,19.22 c15.8,0,23.92-7.26,23.92-16.45c0-10.46-8.55-13.66-30.97-18.79c-30.97-7.05-52.97-15.81-52.97-44.21 c0-27.12,22.21-45.7,54.25-45.7c23.91,0,42.49,7.48,57.44,20.29l-16.44,22.64c-13.03-10.47-27.77-16.24-41.86-16.24 c-13.46,0-21.58,7.05-21.58,15.81c0,10.68,8.77,14.1,31.39,19.22c31.61,7.05,52.55,16.45,52.55,43.56 c0,27.98-21.14,46.57-57.03,46.57C735.48,444.65,712.84,436.1,695.75,420.3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    className: "st1",
    d: "M17.66,211v129.1h98.59V211H78.67v91.51H55.25V211H17.66z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    className: "st1",
    d: "M154.93,409.27H-21.02V141.82h122.03v-37.58h-159.6v342.62h251.11V195.74h-37.59V409.27z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    className: "st1",
    d: "M192.51,104.17v-30.5h-37.59v30.5h-30.5v37.59h30.5v30.5h37.59v-30.5h30.5v-37.59H192.51z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.77feb1e40378f4fc390e747b37766118.svg";
export { ForwardRef as ReactComponent };